module.exports = __webpack_public_path__ + "static/vector-shape6-ed1e8bd8932bdbab40485493b5d6071f.png";